import { render, staticRenderFns } from "./PartnerBranches.vue?vue&type=template&id=5b9bec2f&scoped=true"
import script from "./PartnerBranches.vue?vue&type=script&lang=js"
export * from "./PartnerBranches.vue?vue&type=script&lang=js"
import style0 from "./PartnerBranches.vue?vue&type=style&index=0&id=5b9bec2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9bec2f",
  null
  
)

export default component.exports